import React from "react";

import { Tooltip, styled } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Pause, PlayArrow } from "@mui/icons-material";

const PlayButtonWrapper = styled("div", {
  shouldForwardProp: (prop) => prop !== "mobile" && prop !== "disabled",
})(({ theme, mobile, disabled }) => ({
  flexShrink: 0,
  width: mobile ? "30px" : "40px",
  height: mobile ? "30px" : "40px",
  marginRight: mobile ? 0 : "16px",
  borderRadius: "50%",
  border: `2px solid ${theme.palette.brand?.red}`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: disabled ? "not-allowed" : "pointer",
  backgroundColor: "transparent",
  opacity: disabled ? 0.3 : 1,
  "&:hover": {
    backgroundColor: alpha(theme.palette.brand?.red, 0.08),
  },
  "& .MuiSvgIcon-root": {
    color: theme.palette.brand?.red,
    fontSize: mobile ? "20px" : "28px",
    pointerEvents: "none",
  },
}));

/**
 * Play/pause button for KlimaSlider.
 * Stateless: renders UI and calls onToggle.
 * Pass mobile=true for the compact mobile variant.
 */
function PlayToggleButton({
  playing,
  onToggle,
  mobile = false,
  disabled = false,
}) {
  return (
    <Tooltip
      title={
        disabled
          ? ""
          : `Hier klicken um die automatische Darstellung der Zeiträume zu ${
              playing ? "deaktivieren" : "aktivieren"
            }`
      }
      placement="top"
    >
      <PlayButtonWrapper
        onClick={disabled ? undefined : onToggle}
        mobile={mobile}
        disabled={disabled}
      >
        {playing ? <Pause /> : <PlayArrow />}
      </PlayButtonWrapper>
    </Tooltip>
  );
}

export default PlayToggleButton;
